export default __webpack_public_path__ + "static/media/shopee.alt.0e96fa75.png";